<template>
    <div class="checkout-payment">
        <div class="checkout-payment__security-wrapper">
            <span class="checkout-payment__security-text">{{ $t('checkout.allData') }} <span class="checkout-payment__security-text--medium">{{ $t('checkout.secured') }}</span></span>
            <i class="checkout-payment__security-icon fas fa-lock-alt"></i>
        </div>
        <div class="checkout-selected-payment-card">
            <div class="checkout-selected-payment-card__header-wrapper">
                <h2 class="checkout-selected-payment-card__title">{{ $t("checkout.paymentCardHeaderTitle") }}</h2>
                <div class="text-center button-brekz button-brekz--cart button-brekz--rounded button-brekz--yellow button--icon-left text--gray-600 ml-auto" v-if="selectedPaymentOption" @click='selectedPaymentOption = false'>
                    <i class="fas fa-pencil-alt mr-2"></i>
                    <span class="d-none d-md-inline-block">{{ $t("myAccount.adjust") }}</span>
                </div>
            </div>
            <div class="checkout-selected-payment-card__body-wrapper">
                <ul class="checkout-selected-payment-card__payment-option-list" v-if="!selectedPaymentOption">
                    <li v-for="paymentOption in paymentOptions">
                        <div class="checkout-selected-payment-card__payment-option-list-item">
                            <label class="m-0 checkout-selected-payment-card__input-wrapper" @click="selectedPaymentOption = paymentOption" :for="`pay_${paymentOption.pm_name}`">
                                <input class="checkout-selected-payment-card__input" type="radio" name="id_payment_method" :id="`pay_${paymentOption.pm_name}`" />
                                <input type="hidden" :name="`${paymentOption.pm_name}_url`" :value="paymentOption.checkout_link" />

                                <div class="checkout-selected-payment-card__payment-option-name-wrapper">
                                    <div class="checkout-selected-payment-card__most_used" v-if="idShop === 4 && paymentOption.pm_name === 'IDEAL'">
                                        {{ $t('checkout.mostUsed')}}
                                    </div>
                                    <div class="checkout-selected-payment-card__payment-option-image-wrapper">
                                        <img :src="paymentOption.image" class="checkout-selected-payment-card__payment-option-image" />
                                    </div>
                                    <span class="checkout-selected-payment-card__payment-option-text">{{ paymentOption.name }}</span>
                                </div>
                            </label>

                            <span class="checkout-selected-payment-card__payment-option-fee" :class="{'free': paymentOption.free }">{{ paymentOption.price }}</span>
                            <p class="checkout-selected-payment-card__payment-option-additional-text" v-if="(idShop === 10 || idShop === 7) && paymentOption.pm_name === 'BANK_TRANSFER'">(Via Deutsche Bank)</p>
                        </div>
                    </li>
                </ul>
                <ul class="checkout-selected-payment-card__payment-option-list" v-else>
                    <li>
                        <div class="checkout-selected-payment-card__payment-option-list-item checkout-selected-payment-card__payment-option-list-item--selected">
                            <div class="m-0 checkout-selected-payment-card__input-wrapper" @click='selectedPaymentOption = null'>
                                <div style="display: flex; height: 13px; width: 13px; border-radius: 100%; border: 1px solid rgb(15, 108, 252);">
                                    <div style="height: 7px; width: 7px; margin: auto; border-radius: 100%; background-color: rgb(15, 108, 252);"></div>
                                </div>
                                <input type="hidden" :name="`${selectedPaymentOption.pm_name}_url`" :value="selectedPaymentOption.checkout_link" />
                                <div class="checkout-selected-payment-card__payment-option-name-wrapper checkout-selected-payment-card__payment-option-name-wrapper--selected">
                                    <div class="checkout-selected-payment-card__payment-option-image-wrapper">
                                        <img :src="selectedPaymentOption.image" class="checkout-selected-payment-card__payment-option-image" />
                                    </div>
                                    <span class="checkout-selected-payment-card__payment-option-text" v-text="selectedPaymentOption.name"/>
                                </div>
                            </div>

                            <span class="checkout-selected-payment-card__payment-option-fee" :class="{'free': selectedPaymentOption.free }">{{ selectedPaymentOption.price }}</span>
                            <p class="checkout-selected-payment-card__payment-option-additional-text" v-if="(idShop === 10 || idShop === 7) && selectedPaymentOption.pm_name === 'BANK_TRANSFER'">(Via Deutsche Bank)</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "CheckoutSelectPayment",
    props: {
        paymentOptions: Array,
        rememberedProvider: String,
        idLang: Number,
        idShop: Number,
    },
    data() {
      return {
          selectedPaymentOption: null
      }
    },
    watch: {
        selectedPaymentOption: {
            immediate: true,
            handler(newPaymentOption) {
                if (newPaymentOption && newPaymentOption.pm_name === 'KLARNA' && id_shop !== 10 && id_shop !== 7) {
                    document.getElementById('klarna_fee').style.display = 'block';
                } else {
                    document.getElementById('klarna_fee').style.display = 'none';
                }

                this.$emit('payment-method-selected', newPaymentOption ? newPaymentOption.pm_name : null);

                if (! newPaymentOption) {
                    this.pushGAEvent("begin_edit_payment", {});
                }
            }
        }
    },
    mounted() {
        if (this.rememberedProvider) {
            const rememberedPaymentOption = this.paymentOptions.find((method) => method.pm_name === this.rememberedProvider);

            if (rememberedPaymentOption) {
                this.selectedPaymentOption = rememberedPaymentOption;
            }
        }
    },
    methods: {
        pushGAEvent(event, data) {
            if (typeof window.pushGAEvent === 'function') {
                window.pushGAEvent(event, data);
            }
        }
    },
};
</script>
